import { TableHeader } from '@/components/ui/table';

export function ComplianceStatusHeader() {
  return (
    <TableHeader narrow className="text-left align-bottom">
      Compliance Status
    </TableHeader>
  );
}
